module.exports = __webpack_public_path__ + "img/5.91b5a06c.jpg";